export default __webpack_public_path__ + "static/media/background.eb790aaf.svg";